import React from 'react'

function PaginationNextArrow() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='0.5'
        y='0.5'
        width='31'
        height='31'
        rx='2.5'
        fill='white'
        stroke='#EEEEEE'
      />
      <path
        d='M13.5 21L18.5 16L13.5 11'
        stroke='#6479D6'
        strokeWidth='2'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  )
}

export default PaginationNextArrow
